import defaultFn from './default';
import disabled from './disabled';

export default {
  default: defaultFn,
  disabled,
};
